import React from 'react';
import './gridMasonry.css'

const GridMasonry = (props) => {
    const { title, arrayImages } = props;
    return (
        <div className='masonry-wrapper'>
            <div className='masonry'>
                <div className="masonry-content">
                    {arrayImages.map((img, index) => {
                        return (
                            <div className={`masonry-d${index} masonry-item`} key={index}>
                                <img src={img} alt="" />
                            </div>
                        );
                    })}
                    <div className="masonry-blueSquare masonry-item">
                        <p>
                            {title}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GridMasonry;
